import React from 'react';
import '../styles.css';
import axios from 'axios';
import { DB_HOST, ENDP_PORT } from '../global_variables';
import { useState, useEffect } from 'react';

const Title = () => (
    <>
        <h1>Forgot your password?</h1>
        <h3>Enter your email to recover your password.</h3>
    </>
);

const ForgotPasswordForm = ({setEmailValid, setEmail}) => {
    
    const handleRecoverPasswordClick = async (e) => {
        e.preventDefault();
        // If email exists, send recoverwy code.
        // else take to error page.
        const email = document.getElementById('forgotPassword').value.trim();
        const API_IP = `http://${DB_HOST}:${ENDP_PORT}`;
        try {
            // Check if the email exists
            const url = `${API_IP}/api/accountCheck/?email=${email.toLowerCase()}`;
            const { data } = await axios.get(url);
            
            setEmailValid(data);
            setEmail(email);
            
            // If email is valid, send the recovery code
            if (data) {
                const api_ip_password = `http://${DB_HOST}:${ENDP_PORT}/api/password`;
                const response = await axios.post(api_ip_password, { email: email.toLowerCase() });
                const responseData = response.data;
                console.log(responseData);
            } else {
                setEmailValid(false);
            }
        } catch (error) {
            setEmailValid(false);
            console.error(error);
        }
        // in case data is true
    }

    return (
        <form className='inputForm marginTop40'>
            <input
                id='forgotPassword'
                type='email'
                name='email'
                placeholder='Email address'
                className='inputText'
            />
            <button
                className='button marginLeftAuto'
                onClick={handleRecoverPasswordClick}>
                    Next
            </button>
        </form>
    );
};

const EnterCode = ({email}) => {

    console.log(email);

    const handleCodeReceived = async (e) => {
        e.preventDefault();

        const code = document.getElementById('codePassword').value;
        console.log(code);

        console.log()
    }

    return (
        <>
            <h1>We have emailed you a confirmation code.</h1>
            <h3>
                If an account exists with that email, you will recieve a code.<br />
                Please enter it bellow.
            </h3>
            <form className='inputForm marginTop40'>
                <input
                    id='codePassword'
                    type='password'
                    name='codePassword'
                    placeholder='Enter the token received'
                    className='inputText'
                />
                <button
                    className='button marginLeftAuto'
                    onClick={handleCodeReceived}>
                    Submit
                </button>
            </form>
        </>
    );
};

const EmailNotFound = () => {
    return (
        <>
            <h1>That email wasn't found.</h1>
            <h3>
                The email address may have been entered incorrectly<br />
                or it may not be associated with an existing account.<br />
                Please try again, or if you don't already have an<br />
                account, please <a href="/register/">sign up now.</a>
            </h3>
        </>
    );
};
    
const ForgotPassword = () => {
    const [emailValid, setEmailValid] = useState(null);
    const [email, setEmail] = useState('');

    return (
        <div className='contentContainer'>
            {emailValid === null && (
                <>
                    <Title />
                    <ForgotPasswordForm setEmail={setEmail} setEmailValid={setEmailValid} />
                </>
            )}
            {emailValid === true && <EnterCode email={email} />}
            {emailValid === false && <EmailNotFound />}
        </div>
    )
}

export default ForgotPassword;